import { render, staticRenderFns } from "./_SettingHE.vue?vue&type=template&id=3c7880f7&"
import script from "./_SettingHE.vue?vue&type=script&lang=js&"
export * from "./_SettingHE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports